import useIsGroupAdmin from '@hooks/useIsGroupAdmin';
import {
    Box,
    DialogContentText,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
} from '@mui/material';
import { useInterviewOptions } from '@providers/InterviewsProvider';
import { AccessRole, UserCreationForm, getGroupClaimsKey } from '@synergetx/puppet-interview-types';
import { useFormikContext } from 'formik';
import { memo } from 'react';

const UserFormAdminSelect = () => {
    const { setFieldValue, values } = useFormikContext<UserCreationForm>();
    const { selectedInterview } = useInterviewOptions();
    const groupId = selectedInterview?.groupId;
    const isGroupAdmin = useIsGroupAdmin();

    const handleChange = (event: SelectChangeEvent) => {
        const optionChosen = event.target.value as AccessRole;
        setFieldValue('claims', { [`group_${groupId}`]: optionChosen });
    };

    return (
        <Grid>
            <DialogContentText sx={{ marginBottom: '1rem' }}>
                Select role for this user:
            </DialogContentText>

            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    flexDirection: 'column',
                }}
            >
                <FormControl fullWidth>
                    <InputLabel shrink htmlFor="permission-level-select">
                        Admin Permissions
                    </InputLabel>
                    <Select
                        id="permission-level-select"
                        displayEmpty
                        label="Admin Permissions"
                        onChange={handleChange}
                        value={
                            (groupId && values.claims[getGroupClaimsKey(groupId)]) ||
                            AccessRole.NONE
                        }
                    >
                        <MenuItem value={AccessRole.NONE}>None</MenuItem>
                        <MenuItem value={AccessRole.ASSESSOR}>Assessor</MenuItem>
                        <MenuItem value={AccessRole.SUPERVISOR}>Project Lead</MenuItem>
                        {isGroupAdmin ? <MenuItem value={AccessRole.ADMIN}>Admin</MenuItem> : null}
                    </Select>
                </FormControl>
            </Box>
        </Grid>
    );
};

export default memo(UserFormAdminSelect);
